import * as actions from './inventoryIntraBranch/actions'
import * as mutations from './inventoryIntraBranch/mutations'
import * as getters from './inventoryIntraBranch/getters'

import { dataProps } from './inventoryIntraBranch/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '', 
search_term_array: []
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryIntraBranch.js